import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { IoHomeOutline, IoChatbubbleEllipsesOutline, IoKeyOutline } from "react-icons/io5";
import api from "@/api";
import { useAuth } from "@/auth";
import { tapLight } from "@/utils/haptics";

export const BottomNav = () => {
  const { isTitolare, user } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    const load = async () => {
      if (document.hidden) return;
      try {
        const { data } = await api.get("/chat/unread");
        if (!cancelled) setUnread(data?.conversations_with_unread || 0);
      } catch {
        // network / offline: leave as-is
      }
    };
    load();
    const timer = setInterval(load, 20000);
    const onFocus = () => load();
    const onRead = () => load();
    const onVis = () => { if (!document.hidden) load(); };
    window.addEventListener("focus", onFocus);
    window.addEventListener("chat-unread-changed", onRead);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      cancelled = true;
      clearInterval(timer);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("chat-unread-changed", onRead);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [user]);

  // Order (Titolare): Home, Chat, Credenziali
  // Order (Direttore): Home, Chat
  const items = [
    { to: "/", label: "Home", Icon: IoHomeOutline, testid: "nav-dashboard", end: true, badge: 0 },
    { to: "/chat", label: "Chat", Icon: IoChatbubbleEllipsesOutline, testid: "nav-chat", end: false, badge: unread },
  ];
  if (isTitolare) {
    items.push({ to: "/credentials", label: "Credenziali", Icon: IoKeyOutline, testid: "nav-credentials", end: false, badge: 0 });
  }

  return (
    <nav className="tf-bottom-nav" data-testid="bottom-nav" aria-label="Navigazione principale">
      <div className="tf-bottom-nav-inner">
        {items.map(({ to, Icon, label, testid, end, badge }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            onClick={() => tapLight()}
            className={({ isActive }) => `tf-nav-item${isActive ? " active" : ""}`}
          >
            <span className="tf-nav-icon-wrap">
              <Icon size={22} />
              {badge > 0 && (
                <span className="tf-nav-badge" data-testid={`${testid}-badge`}>{badge > 9 ? "9+" : badge}</span>
              )}
            </span>
            <span className="tf-nav-label">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
